import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Text, Loader, Box, Stack, Center } from "@mantine/core";
import { Rizvoice } from "../stores/Rizvoice";
import GenericInvoiceQR from "./genericInvoiceQR";
import PaySubscription from "./paySubscription";

const RizvoiceModals = observer(({ rizvoice }: { rizvoice: Rizvoice }) => {
  return (
    <>
      <PaySubscription rizvoice={rizvoice} />
    </>
  );
});

export default RizvoiceModals;
